
import React, { useEffect, useState } from 'react';
import { Box,} from '@mui/material';
import { ClinicInfoFormData, ClinicListResponse, getClinicList } from '../../../components/ClinicConfiguration/clinicHelper';
import ClinicListHeader from '../../../components/ClinicConfiguration/ClinicListHeader';
import ClinicTable from '../../../components/ClinicConfiguration/ClinicTable';
// import ClinicAddEditInfoForm from '../../../components/ClinicConfiguration/ClinicAddEditInfoForm';
import { useNavigate } from 'react-router-dom';
import ViewClinicDetails from '../../../components/ClinicConfiguration/ViewClinicDetails';
import ClinicAddEditInfoForm from '../../../components/ClinicConfiguration/ClinicAddEditInfoForm';



const ClinicConfig: React.FC = () => {
  const [clinicList, setClinicList] = useState<ClinicInfoFormData[]>();
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);
  const [isView, setIsView] = useState(false);
  const [viewClinicId, setViewClinicId] = useState<number  | null>(null);

  useEffect(() => {
    getClinicList(search)
      .then((response: ClinicListResponse) => {
        setClinicList(response.objects);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching clinics', err);
      });
  }, [search]);

  const handleEdit = (clinic: ClinicInfoFormData) => {
    if (clinic && clinic.id) {
      navigate(`/ai/configuration/clinic/${clinic.id}`);
    }
  };

  const handleView = (clinic: ClinicInfoFormData) => {
    if (clinic && clinic.id) {
      setViewClinicId(clinic.id);
      setIsView(true);
    }
  };

  return (
    <Box p={3}>
      {isView ? (
        <ViewClinicDetails id={viewClinicId} onBack={() => setIsView(false)} />
      ) : isAdding ? (
        <ClinicAddEditInfoForm onCancel={() => setIsAdding(false)} />
      ) : (
        <>
          <ClinicListHeader search={search} onSearchChange={setSearch} onCreate={() => setIsAdding(true)} />
          <ClinicTable clinics={clinicList ?? []}  onEdit={handleEdit} onView={handleView} />
        </>
      )}
    </Box>
  );
};

export default ClinicConfig;
